<template>
  <navbar :show-navbar="showNavbar">
    <div class="navbar-wrapper">
      <div class="navbar-toggle" :class="{ toggled: $sidebar.showSidebar }">
        <navbar-toggle-button @click.native="toggleSidebar">
        </navbar-toggle-button>
      </div>
      <a class="navbar-brand" href="">
        {{ $route.name }}
      </a>
    </div>
    <button @click="toggleNavbar" class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navigation"
      aria-controls="navigation-index" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
    </button>

    <template slot="navbar-menu">
      <p class="p-0 m-0 mr-3 my-auto"><b>{{ $store.getters['user'].name }}</b></p>
      <ul class="navbar-nav-notifications">
        <drop-down-notification tag="li" position="right" class="nav-item" icon="now-ui-icons ui-1_bell-53">
          <span v-if="$store.getters['notifications']?.length">
            <notification v-for="notification in $store.getters['notifications']" :notification="notification" :key="notification.id">
            </notification>
          </span>
          <p v-else class="no-notifications">Nenhuma notificação</p>
        </drop-down-notification>
      </ul>
      <ul class="navbar-nav">
        <drop-down tag="li" position="right" class="nav-item" icon="now-ui-icons users_single-02">
          <a @click="logout()" class="dropdown-item nav-link">Sair</a>
        </drop-down>
      </ul>
    </template>
  </navbar>
</template>
<script>
import { Navbar, NavbarToggleButton } from "src/components";
import { Switch } from "src/components/index";
import Notification from "src/components/NotificationCustom/Notification.vue";

export default {
  components: {
    Navbar,
    NavbarToggleButton,
    [Switch.name]: Switch,
    Notification
  },
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    theme_mode: {
      get() {
        return this.$store.getters["theme_mode"];
      },
      set(value) {
        this.$store.commit("SET_THEME_MODE", value);
      },
    },
  },
  data() {
    return {
      activeNotifications: false,
      showNavbar: false,
    };
  },
  methods: {
    profile() {
      // this.$route.push();
    },
    logout() {
      this.$store.dispatch("logout");
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    toggleNavbar() {
      this.showNavbar = !this.showNavbar;
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    }
  },
};
</script>
<style lang="scss" scoped>
.nav-link {
  font-weight: 500;
  font-size: .8rem !important;
  color: black !important;
}

.nav-link:hover {
  cursor: pointer;
  color: darkgrey !important;
}
</style>
